document.addEventListener("DOMContentLoaded", function() {
  // Captura clicks en enlaces con hash #merckens-shop-now
  document.querySelectorAll('a[href="#merckens-shop-now"]').forEach(function(link) {
    link.addEventListener("click", function(e) {
      e.preventDefault();

      // Buscar el elemento con el texto Merckens
      const target = Array.from(document.querySelectorAll('h2.section__heading'))
        .find(el => el.textContent.trim().toLowerCase() === "merckens' products");

      if (target) {
        const offset = -100; // Ajusta si tienes header fijo
        const y = target.getBoundingClientRect().top + window.pageYOffset + offset;
        window.scrollTo({ top: y, behavior: "smooth" });
      } else {
        console.warn("No se encontró el título Merckens en la página.");
      }
    });
  });
});
